import { useState } from 'react';
import { logoutStaff } from '../../firebase/auth';

function LogoutButton() {
  const [loading, setLoading] = useState(false);

  const handleLogout = async () => {
    setLoading(true);
    const result = await logoutStaff();
    if (result.success) {
      window.location.href = '/login';
    } else {
      alert('Logout failed: ' + result.error);
    }
    setLoading(false);
  };

  return (
    <button 
      onClick={handleLogout} 
      disabled={loading}
      className="px-4 py-2 bg-salon-button text-white rounded-md hover:bg-salon-button-hover disabled:opacity-50 transition"
    >
      {loading ? 'Logging out...' : 'Logout'}
    </button>
  );
}

export default LogoutButton;